export default "__VITE_ASSET__c008f1e8__"